/* eslint-disable max-len */
import React, { FunctionComponent, ReactElement } from 'react';
import classnames from 'classnames';
import './Logo.scss';
import PropTypes from 'prop-types';

interface Props {
  white?: boolean;
  minified?: boolean;
}

const Logo: FunctionComponent<Props> = ({
  white = false,
  minified = false,
}): ReactElement => {
  const classes = classnames({ minified }, 'app-logo');
  return (
    <div className={classes}>
      <svg
        width="100px"
        height="99px"
        viewBox="0 0 100 99"
        version="1.1"
        className="app-logo-icon"
      >
        <path
          d="M49.0283793,0.403525755 L49.0283793,0.403525755 C22.0772405,0.403525755 0.228766495,22.2514903 0.228766495,49.202629 C0.228766495,76.1542773 22.0772405,98.0022418 49.0283793,98.0022418 C75.979518,98.0022418 97.8279921,76.1542773 97.8279921,49.202629 C97.8279921,22.2514903 75.979518,0.403525755 49.0283793,0.403525755"
          id="path-1"
        />
        <linearGradient
          x1="50%"
          y1="100%"
          x2="50%"
          y2="0%"
          id="linearGradient-3"
        >
          <stop stopColor="#07BE76" offset="0%" />
          <stop stopColor="#22DADB" offset="100%" />
        </linearGradient>
        <path
          d="M49.0283793,0.403525755 L49.0283793,0.403525755 C22.0772405,0.403525755 0.228766495,22.2514903 0.228766495,49.202629 C0.228766495,76.1542773 22.0772405,98.0022418 49.0283793,98.0022418 C75.979518,98.0022418 97.8279921,76.1542773 97.8279921,49.202629 C97.8279921,22.2514903 75.979518,0.403525755 49.0283793,0.403525755"
          id="path-4"
        />
        <g
          id="Artboard"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="INTWI-logo-rvb-05-(1)"
            transform="translate(0.000000, 0.000000)"
          >
            <mask id="mask-2" fill="white">
              <use href="#path-1" />
            </mask>
            <g id="Clip-8" />
            <path
              d="M49.0283793,0.403525755 L49.0283793,0.403525755 C22.0772405,0.403525755 0.228766495,22.2514903 0.228766495,49.202629 C0.228766495,76.1542773 22.0772405,98.0022418 49.0283793,98.0022418 C75.979518,98.0022418 97.8279921,76.1542773 97.8279921,49.202629 C97.8279921,22.2514903 75.979518,0.403525755 49.0283793,0.403525755"
              id="Fill-7"
              mask="url(#mask-2)"
            />
            <mask id="mask-5" fill="white">
              <use href="#path-4" />
            </mask>
            <use id="Clip-11" fill="url(#linearGradient-3)" href="#path-4" />
            <path
              d="M69.185306,31.0944108 C68.6951648,29.9256127 67.4565649,28.8169359 67.4565649,23.341825 L67.4565649,-9.60207877 L48.9825241,-9.60207877 C48.9820146,-8.54231416 48.9825241,13.9415091 48.9820146,15.0017833 C48.9820146,18.0567585 44.5447598,23.4692006 38.2880726,23.4692006 C33.5216793,23.6093137 31.0460081,23.5099608 26.2750293,23.5201508 C24.473939,23.5237173 22.5923473,24.2023743 23.093188,25.9428339 C23.566006,27.587507 25.0099353,28.2004382 26.5802211,28.4225811 L30.6485963,29.1002191 L37.7760228,27.4957966 L32.1434758,29.3498752 L32.1419473,29.3498752 L20.0774443,33.3204259 C19.3682173,33.5583635 18.7899322,33.7540123 18.4174861,33.8844449 C16.7723035,34.4581444 16.1542773,36.1904519 17.2053803,37.580374 C17.935497,38.5453712 18.9820146,39.0411168 20.1222805,38.9142508 C21.4062261,38.7710807 23.8166811,38.4205431 25.8760891,38.1102563 L33.3948133,34.8458756 L29.5256534,37.5487848 C29.3075865,37.7189586 25.181128,40.5976461 21.6497682,43.0524278 L21.6283691,43.0672033 C20.2715647,44.0102919 19.0018852,44.8912213 18.0812147,45.528099 C16.552708,46.5858256 16.6077342,48.3410608 18.2004382,49.3259286 C18.6126255,49.5806797 19.1017476,49.7467774 19.5781322,49.8558109 C20.9823203,50.1767973 22.3722423,50.0254751 23.6378458,49.3621032 C24.3047842,49.0125847 25.1164213,48.5586182 25.9688185,48.0735721 L27.5533704,46.8752229 C28.4083151,46.2291741 28.8296734,45.1602384 28.6462526,44.1045499 L27.9319305,39.998981 C30.6801855,45.4312936 30.699037,55.2494013 30.699037,55.2494013 C30.694961,56.7931931 32.3931319,57.7449432 33.7056096,56.9312682 C35.7212004,55.6819687 37.0397921,53.444235 37.0229785,50.927294 C37.0127885,49.4538136 36.9939369,44.0408621 36.9801804,42.9352423 C36.9786519,42.7956387 36.9898609,42.6748866 37.0087125,42.5607581 L37.0087125,40.7922759 L49.4242625,32.6045753 L61.8398125,41.6237836 L61.8398125,42.3910939 C61.8943292,42.5546441 61.9294849,42.7360269 61.9264279,42.9637744 C61.8856677,45.4379172 61.8795537,48.4816834 61.9228614,51.5111836 C61.961074,54.1988078 63.5379834,56.1063841 65.9749325,56.5532175 C67.6598563,56.8624854 68.9188363,55.6508891 68.7211494,53.9491517 C68.614154,53.0269527 68.4796454,52.1062822 68.4261477,51.1800071 C68.2228563,47.6725939 68.7094309,44.2451725 69.7060172,40.8850053 C70.6913945,37.5615224 70.5395628,34.3246548 69.185306,31.0944108"
              id="Fill-10"
              fill="#FFFFFF"
              mask="url(#mask-5)"
            />
            <path
              d="M52.0074387,50.3383095 L56.9827279,50.3383095 L56.9827279,45.3635298 L52.0074387,45.3635298 L52.0074387,50.3383095 Z M52.0074387,60.2873593 L56.9827279,60.2873593 L56.9827279,55.3130891 L52.0074387,55.3130891 L52.0074387,60.2873593 Z M52.0074387,70.2369185 L56.9827279,70.2369185 L56.9827279,65.2621389 L52.0074387,65.2621389 L52.0074387,70.2369185 Z M42.0573699,50.3383095 L47.0326591,50.3383095 L47.0326591,45.3635298 L42.0573699,45.3635298 L42.0573699,50.3383095 Z M42.0573699,60.2873593 L47.0326591,60.2873593 L47.0326591,55.3130891 L42.0573699,55.3130891 L42.0573699,60.2873593 Z M42.0573699,70.2369185 L47.0326591,70.2369185 L47.0326591,65.2621389 L42.0573699,65.2621389 L42.0573699,70.2369185 Z"
              id="Fill-12"
              fill="#FFFFFF"
              mask="url(#mask-5)"
            />
          </g>
        </g>
      </svg>
      <svg
        width="460px"
        height="150px"
        viewBox="0 0 460 150"
        version="1.1"
        className="app-logo-text"
      >
        <g
          id="Artboard"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="INTWI-logo-rvb-04"
            transform="translate(2.000000, 2.000000)"
            fill={white ? '#ffffff' : '#182945'}
          >
            <path
              d="M121.567,46.405 L60.128,46.405 L60.128,145.439 L82.892,145.439 L82.892,69.164 L117.07,69.164 L117.07,145.439 L139.833,145.439 L139.833,64.67 C139.833,54.583 131.656,46.405 121.567,46.405"
              id="Fill-1"
            />
            <polygon
              id="Fill-2"
              points="3.159 145.439 25.923 145.439 25.923 46.405 3.159 46.405"
            />
            <path
              d="M14.541,0.479 C6.765,0.479 0.46,6.783 0.46,14.56 C0.46,22.336 6.765,28.64 14.541,28.64 C22.318,28.64 28.622,22.336 28.622,14.56 C28.622,6.783 22.318,0.479 14.541,0.479"
              id="Fill-3"
            />
            <polygon
              id="Fill-4"
              points="430.317 145.439 453.08 145.439 453.08 46.405 430.317 46.405"
            />
            <path
              d="M441.698,28.64 C449.475,28.64 455.779,22.336 455.779,14.56 C455.779,6.783 449.475,0.479 441.698,0.479 C433.921,0.479 427.617,6.783 427.617,14.56 C427.617,22.336 433.921,28.64 441.698,28.64"
              id="Fill-5"
            />
            <path
              d="M373.355,122.675 L339.036,122.675 L339.036,46.405 L316.273,46.405 L316.273,122.675 L281.953,122.675 L281.953,46.405 L158.309,46.405 L158.309,69.169 L197.413,69.169 L197.413,145.439 L220.177,145.439 L220.177,69.169 L259.19,69.169 L259.19,127.135 C259.19,137.244 267.385,145.439 277.493,145.439 L396.118,145.439 L396.118,46.405 L373.355,46.405 L373.355,122.675"
              id="Fill-6"
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

Logo.propTypes = {
  white: PropTypes.bool,
  minified: PropTypes.bool,
};

export default Logo;
